import { makeRequest } from '../../api/utils/makeRequest';
import { AtlasGetFeaturesResponse } from '../types';

export const getAtlasFeatures = async (): Promise<AtlasGetFeaturesResponse[]> => {
  const response = await makeRequest('/atlas-api/store/pm/features', { method: 'GET' });

  if (response.ok) {
    return response.json();
  }

  throw new Error(response.statusText);
};
